export default __webpack_public_path__ + "static/media/bancamia.4e572fbe.svg";